import AutoNumeric from '@/components/autonumeric/VueAutonumeric';
import localReferences from '@/helpers/localReferences';
import { pickerOptions } from '@/common/pickerOptions';

const incomeMixin = {
    components: {
        AutoNumeric
    },
    data() {
        return {
            localReferences,
            pickerOptions,
            numericOptions: {
                digitGroupSeparator: ' ',
                decimalCharacter: ',',
                decimalPlaces: 0,
                decimalCharacterAlternative: '.',
                roundingMethod: 'U',
                minimumValue: '0',
                maximumValue: '9999999',
                isCancellable: true,
                emptyInputBehavior: 'null',
                modifyValueOnWheel: false
            },
            receivedByTypesList: [
                {
                    id: 'employer',
                    name: 'Сотрудник'
                },
                {
                    id: 'cash',
                    name: 'Касса'
                },
                {
                    id: 'factory',
                    name: 'Производство'
                }
            ],
            receivedFromTypesList: [
                {
                    id: 'contact',
                    name: 'Клиент'
                },
                {
                    id: 'employer',
                    name: 'Сотрудник'
                }
            ],
            receivedFromIdList: []
        };
    },
    computed: {
        employersList() {
            return this.$store.state.references.employers;
        },
        cashesList() {
            return this.$store.state.references.cashes;
        },
        factoriesList() {
            return this.$store.state.references.factories;
        },
        payTypesList() {
            return this.$store.state.references.payTypes;
        },
        operationStatusesList() {
            return this.$store.state.references.operationStatuses;
        },
        detailsList() {
            return this.$store.state.references.incomeDetails;
        }
    },
    methods: {
        searchReceivedFrom(query) {
            if (query === '') {
                return [];
            }
            if (this.receivedFromType === 'employer') {
                this.receivedFromIdList = this.employersList.filter(item => {
                    return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
                });
            } else {
                const queryString = query.replace(/[^0-9A-zА-я.@/-]?/g, '');
                this.$store.dispatch('search/searchContactByDeals', { query: queryString }).then(
                    response => {
                        this.receivedFromIdList = [...response];
                    }
                ).catch(() => {
                    this.receivedFromIdList = [];
                });
            }
        },
        getDealLink(dealId) {
            return this.$router.resolve({ name: 'deal-card', params: { id: '' + dealId } }).href;
        },
        getPayTypeCategoryByPayType(payType) {
            if (payType === localReferences.payTypesFull.cash) {
                return localReferences.payTypes.cash;
            }
            if (localReferences.payTypesFullCashless.indexOf(payType) !== -1) {
                return localReferences.payTypes.cashless;
            }
            if (payType === localReferences.payTypesFull.card) {
                return localReferences.payTypes.card;
            }
        },
        getCashId(payTypeId, officeId) {
            const payTypeCategoryId = this.getPayTypeCategoryByPayType(payTypeId);
            const cash = this.cashesList.filter(item => (item.pay_type_category.id === payTypeCategoryId && item.office_id === officeId))[0];
            if (cash !== -1) {
                return cash.id;
            }
            return null;
        }
    }
};

export default incomeMixin;
